import { render, staticRenderFns } from "./PerformanceDetails.vue?vue&type=template&id=33ee3e21&scoped=true"
import script from "./PerformanceDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./PerformanceDetails.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PerformanceDetails.vue?vue&type=style&index=0&id=33ee3e21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee3e21",
  null
  
)

export default component.exports